import React from "react";
var __jsx = React.createElement;
import { useIntl } from 'react-intl';
import { HighlightToggle } from 'components/common/RichTextEditor/tools/InlineToolbar/InlineToolbar.style';
import { isHighlightedBlock } from 'components/common/RichTextEditor/util/block';
import { Tag } from 'theme/icons';

var HighlightTab = function HighlightTab(_ref) {
  var firstSelectedBlock = _ref.firstSelectedBlock,
      handleHighlightToggle = _ref.handleHighlightToggle;
  var intl = useIntl();
  var label = intl.formatMessage({
    id: 'content.labels.inline-toolbar.highlight'
  });
  return __jsx(React.Fragment, null, __jsx(HighlightToggle, {
    onMouseDown: handleHighlightToggle(),
    toggled: isHighlightedBlock(firstSelectedBlock),
    title: label,
    "aria-label": label
  }, __jsx(Tag, null)));
};

export default HighlightTab;